// istanbul ignore file
import { AppId, ApplicationInfo, ApplicationsInfo, ApplicationsListCategories } from '../../ApplicationWrapper.types';
import {
  DAM_PATH,
  MEDIA_FLOWS_PATH,
  ME_PATH,
  MM_PATH,
  MO_PATH,
  PM_PATH,
  PRODUCT_EXPLORER_PATH,
  DIMENSIONS_PATH,
  SETTINGS_PAGE_URL,
  FINAL_TOUCH_PATH,
  VIDEO_PATH,
} from '../../ApplicationWrapper.const';
import assetsActiveIcon from './icons/assetsActive.svg';
import assetsInactiveDarkIcon from './icons/assetsInactiveDark.svg';
import assetsInactiveLightIcon from './icons/assetsInactiveLight.svg';
import dimensionsActiveIcon from './icons/dimensionsActive.svg';
import dimensionsInactiveDarkIcon from './icons/dimensionsInactiveDark.svg';
import dimensionsInactiveLightIcon from './icons/dimensionsInactiveLight.svg';
import finalTouchActiveIcon from './icons/finalTouchActive.svg';
import finalTouchInactiveDarkIcon from './icons/finalTouchInactiveDark.svg';
import finalTouchInactiveLightIcon from './icons/finalTouchInactiveLight.svg';
import mediaFlowsActiveIcon from './icons/mediaFlowsActive.svg';
import mediaFlowsInactiveDarkIcon from './icons/mediaFlowsInactiveDark.svg';
import mediaFlowsInactiveLightIcon from './icons/mediaFlowsInactiveLight.svg';
import mediaOptimizerActiveIcon from './icons/mediaOptimizerActive.svg';
import mediaOptimizerInactiveDarkIcon from './icons/mediaOptimizerInactiveDark.svg';
import mediaOptimizerInactiveLightIcon from './icons/mediaOptimizerInactiveLight.svg';
import programmableMediaActiveIcon from './icons/programmableMediaActive.svg';
import programmableMediaInactiveDarkIcon from './icons/programmableMediaInactiveDark.svg';
import programmableMediaInactiveLightIcon from './icons/programmableMediaInactiveLight.svg';
import videoActiveIcon from './icons/videoActive.svg';
import videoInactiveDarkIcon from './icons/videoInactiveDark.svg';
import videoInactiveLightIcon from './icons/videoInactiveLight.svg';
import settingsActiveIcon from './icons/settings.svg';

export const productExplorerApplicationInfo: ApplicationInfo = {
  href: ({ customerExternalId }) => PRODUCT_EXPLORER_PATH.replace('{customerId}', `/c-${customerExternalId}`),
  appId: AppId.ProductExplorer,
  description: 'productExplorerDescription',
  name: 'productExplorerName',
  isBeta: false,
  openInNewWindow: false,
  iconActive: '',
  iconInactiveDark: '',
  iconInactiveLight: '',
};

export const applicationsInfo: ApplicationsInfo = {
  [AppId.MediaManagement]: {
    iconActive: programmableMediaActiveIcon,
    iconInactiveDark: programmableMediaInactiveDarkIcon,
    iconInactiveLight: programmableMediaInactiveLightIcon,
    name: 'mediaManagementName',
    description: 'mediaManagementDescription',
    appId: AppId.MediaManagement,
    href: () => MM_PATH,
    isBeta: true,
    openInNewWindow: false,
  },
  [AppId.Settings]: {
    iconActive: settingsActiveIcon,
    iconInactiveDark: '',
    iconInactiveLight: '',
    name: 'settingsName',
    description: 'settingsDescription',
    appId: AppId.Settings,
    isBeta: false,
    href: () => SETTINGS_PAGE_URL,
    openInNewWindow: false,
  },
  [AppId.ProgrammableMediaEditor]: {
    iconActive: programmableMediaActiveIcon,
    iconInactiveDark: programmableMediaInactiveDarkIcon,
    iconInactiveLight: programmableMediaInactiveLightIcon,
    name: 'mediaEditingName',
    description: 'mediaEditingDescription',
    appId: AppId.ProgrammableMediaEditor,
    href: () => ME_PATH,
    isBeta: true,
    openInNewWindow: false,
  },
  [AppId.MediaOptimizer]: {
    iconActive: mediaOptimizerActiveIcon,
    iconInactiveDark: mediaOptimizerInactiveDarkIcon,
    iconInactiveLight: mediaOptimizerInactiveLightIcon,
    name: 'mediaOptimizerName',
    description: 'mediaOptimizerDescription',
    appId: AppId.MediaOptimizer,
    href: () => MO_PATH,
    openInNewWindow: false,
  },
  [AppId.DigitalAssetManagement]: {
    iconActive: assetsActiveIcon,
    iconInactiveDark: assetsInactiveDarkIcon,
    iconInactiveLight: assetsInactiveLightIcon,
    name: 'cloudinaryAssetsName',
    description: 'cloudinaryAssetsDescription',
    appId: AppId.DigitalAssetManagement,
    href: () => DAM_PATH,
    openInNewWindow: false,
  },
  [AppId.CloudinaryAssets]: {
    iconActive: assetsActiveIcon,
    iconInactiveDark: assetsInactiveDarkIcon,
    iconInactiveLight: assetsInactiveLightIcon,
    name: 'cloudinaryAssetsName',
    description: 'cloudinaryAssetsDescription',
    appId: AppId.CloudinaryAssets,
    href: () => DAM_PATH,
    openInNewWindow: false,
  },
  [AppId.Nexus]: {
    iconActive: assetsActiveIcon,
    iconInactiveDark: assetsInactiveDarkIcon,
    iconInactiveLight: assetsInactiveLightIcon,
    name: 'cloudinaryAssetsName',
    description: 'cloudinaryAssetsDescription',
    appId: AppId.Nexus,
    href: () => DAM_PATH,
    openInNewWindow: false,
  },
  [AppId.MediaAPI]: {
    iconActive: programmableMediaActiveIcon,
    iconInactiveDark: programmableMediaInactiveDarkIcon,
    iconInactiveLight: programmableMediaInactiveLightIcon,
    name: 'programmableMediaName',
    description: 'programmableMediaDescription',
    appId: AppId.MediaAPI,
    href: ({ customerExternalId }) => PM_PATH.replace('{customerId}', customerExternalId),
    openInNewWindow: false,
  },
  [AppId.MediaFlows]: {
    iconActive: mediaFlowsActiveIcon,
    iconInactiveDark: mediaFlowsInactiveDarkIcon,
    iconInactiveLight: mediaFlowsInactiveLightIcon,
    name: 'mediaFlowsName',
    description: 'mediaFlowsDescription',
    appId: AppId.MediaFlows,
    href: ({ customerExternalId }) => MEDIA_FLOWS_PATH.replace('{customerId}', customerExternalId),
    isBeta: false,
    openInNewWindow: false,
  },
  [AppId.Dimensions]: {
    iconActive: dimensionsActiveIcon,
    iconInactiveDark: dimensionsInactiveDarkIcon,
    iconInactiveLight: dimensionsInactiveLightIcon,
    name: 'dimensionsName',
    description: 'dimensionsDescription',
    appId: AppId.Dimensions,
    href: ({ customerExternalId }) => DIMENSIONS_PATH.replace('{customerId}', customerExternalId),
    isBeta: false,
    openInNewWindow: true,
  },
  [AppId.FinalTouch]: {
    iconActive: finalTouchActiveIcon,
    iconInactiveDark: finalTouchInactiveDarkIcon,
    iconInactiveLight: finalTouchInactiveLightIcon,
    name: 'finalTouchName',
    description: 'finalTouchDescription',
    appId: AppId.FinalTouch,
    href: () => FINAL_TOUCH_PATH,
    isBeta: false,
    isEarlyAccess: true,
    openInNewWindow: true,
  },
  [AppId.Video]: {
    iconActive: videoActiveIcon,
    iconInactiveDark: videoInactiveDarkIcon,
    iconInactiveLight: videoInactiveLightIcon,
    name: 'videoAppName',
    description: 'videoAppDescription',
    appId: AppId.Video,
    href: ({ customerExternalId }) => VIDEO_PATH.replace('{customerId}', customerExternalId),
    isBeta: false,
    openInNewWindow: false,
  },
};

export const applicationsIdOrder: Record<ApplicationsListCategories, AppId[]> = {
  [ApplicationsListCategories.Media]: [AppId.MediaAPI, AppId.DigitalAssetManagement, AppId.CloudinaryAssets, AppId.Nexus, AppId.MediaOptimizer],
  [ApplicationsListCategories.ProgrammableMedia]: [AppId.MediaManagement, AppId.ProgrammableMediaEditor],
};
